import httpManager from "@/app/shared/utils/httpManager";
import { TABLE_PAGE_SIZE } from "@/app/shared/utils/constants";
import { ReportTypes } from "@/app/reports/utils/enums";

export async function fetchInboundVoice({ filters, page = 1 } = {}) {
  let query = "";
  query += `portfolio=${filters.portfolio}&`;
  if (filters.base) query += `base=${filters.base}&`;
  query += `start_date=${filters.startDate}&`;
  query += `end_date=${filters.endDate}`;

  const offset = (page - 1) * TABLE_PAGE_SIZE;
  const limit = TABLE_PAGE_SIZE;

  const url = `/reports/${ReportTypes.InboundVoice}/?offset=${offset}&limit=${limit}&${query}`;

  const response = await httpManager.get(url);
  return response?.data;
}
